import React from 'react'
import { makeStyles, createStyles, Box, Select } from '@material-ui/core'
import { setLanguage } from 'src/store/slices/authSlice'
import { LANGUAGE_LIST } from 'src/i18n'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import useUserSession from 'src/hooks/useUserSession'
import { ReactComponent as FooterIcon7 } from 'src/mobile/assets/icons/footer_icon7.svg'
import { changePathName } from 'src/utils/replaceURLs'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    boxContainerBottom: {
      backgroundColor: 'white',
      height: theme.spacing(26.25),
      paddingLeft: theme.spacing(2.5),
      fontSize: 14,
      paddingRight: theme.spacing(2),
      fontWeight: 400,
    },
    list: {
      '&:last-child': {
        fontWeight: 500,
      },
    },
    boxBottomText: {
      display: 'inline-block',
      textDecoration: 'underline',
      marginRight: theme.spacing(2),
    },
    boxBottomText2: {
      display: 'flex',
      textDecoration: 'underline',
    },
  }),
)
const Footer = () => {
  const { t, i18n } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const { userInfo, authenticated } = useUserSession()
  const date = new Date()
  // const isClinic = useRouteMatch(`/${i18n.language}/clinic/`)

  const FooterBottomText = [
    {
      label: t('glossary.agreement'),
      path: '/agreement/3',
    },
    {
      label: t('glossary.policy_and_agreement_list.4'),
      path: '/agreement/2',
    },
    {
      label: t('glossary.policy_and_agreement_list.5'),
      path: '/agreement/1',
    },
  ]
  const handleChangeLanguage = async (e) => {
    const language = e.target.value
    language && i18n.changeLanguage(language)
    if (authenticated && userInfo?.id)
      await dispatch(setLanguage({ id: userInfo?.id, language: language })).unwrap()
    changePathName(language, history, pathname)
  }
  return (
    <Box className={classes.boxContainerBottom} mt={2}>
      <Box mt={4} className={classes.boxBottomText2}>
        <FooterIcon7 />
        <Box mt={-0.4} ml={1}>
          <Box>
            <Select
              disableUnderline
              native
              keepMounted
              defaultValue={i18n.language}
              onChange={handleChangeLanguage}
              IconComponent={() => null}
            >
              {LANGUAGE_LIST.map((language, index) => (
                <option key={language.lang + index} value={language.lang}>
                  {t(language.label)}
                </option>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>
      <Box mt={3}>
        {FooterBottomText.map((item, index) => (
          <Box
            key={index}
            className={classes.boxBottomText}
            onClick={() => {
              history.push(item.path)
            }}
          >
            {item.label}
          </Box>
        ))}
      </Box>

      <Box mt={3} color="#4B5563">
        {' '}
        ©{date.getFullYear()} Take2 Health {t('glossary.all_rights_reserved')}
      </Box>
    </Box>
  )
}

export default Footer
